































import { Vue, Component } from "vue-property-decorator";
import { ThinCertificate, CertificateState } from "bancojs";
import { $api } from "@/services/ApiService";
import AgDataTable, { AgDataTableOptions } from "@/components/AgDataTable.vue";
import { DataTableHeader } from "vuetify";

@Component({
  components: {
    AgDataTable,
  },
})
export default class MyCertificatesIndex extends Vue {
  async created() {
    this.table.loading = true;
    const res = await $api.client.user.certificates.find({}).toPromise();
    this.table.data = res.content;
    this.table.loading = false;
  }

  getStateString(val: CertificateState) {
    return val === "ACTIVE"
      ? "Activo"
      : val === "INACTIVE"
      ? "Inactivo"
      : "Eliminado";
  }

  table: {
    loading: boolean;
    data?: ThinCertificate[];
    options: AgDataTableOptions[];
    headers?: DataTableHeader[];
  } = {
    loading: true,
    data: undefined,
    options: [
      {
        header: {
          text: "#",
          value: "$index",
          width: 60,
          filterable: false,
          sortable: false,
        },
        row: {
          type: "INDEX",
        },
      },
      {
        header: {
          text: "Fingerprint",
          value: "fingerprint",
          class: "text-no-wrap",
          width: 500,
        },
        row: {
          type: "LINK",
          to: "{fingerprint}/edit",
          append: true,
        },
      },
      {
        header: {
          text: "Dueño",
          value: "user_id",
          class: "text-no-wrap",
        },
        row: {
          type: "CHIP",
          color: {},
          label: true,
        },
      },
      {
        header: {
          text: "Llave",
          value: "key_id",
          class: "text-no-wrap",
        },
        row: {
          type: "CHIP",
          color: {},
          label: true,
          transform: (val: string) => {
            return "ID: " + val;
          },
        },
      },
      {
        header: {
          text: "Estado",
          value: "state",
          class: "text-no-wrap",
        },
        row: {
          type: "CHIP",
          label: true,
          color: {
            ACTIVE: "success",
            INACTIVE: "warn",
            DELETED: "error",
          },
          transform: this.getStateString,
        },
      },
      {
        header: {
          text: "",
          class: "text-no-wrap",
          value: "$options",
          sortable: false,
          filterable: false,
        },
        row: {
          type: "OPTIONS",
          options: [
            {
              label: "Editar",
              icon: "mdi-pencil",
              link: "{fingerprint}/edit",
              append: true,
            },
          ],
        },
      },
    ],
  };
}
